<script>
export default {
  name: "FaqView"
}
</script>

<template>
  <div align="center" style="padding-top: 80px;padding-bottom: 80px">
    <h1>FAQ to know more about XIYUE</h1>
    <div style="max-width: 80%;padding-top: 80px">
      <b-row no-gutters class="text-left">
        <b-col md="5">
          <h5>Can you help with the structural and graphic design?</h5>
          <p style="padding-top: 10px">Absolutely. We offer end-to-end design services, from creating innovative structural designs that
            protect your product to producing print-ready graphics that elevate your brand.</p>
          <h5 style="padding-top: 60px">What is your Minimum Order Quantity (MOQ)?</h5>
          <p style="padding-top: 10px">Normally MOQ 500pcs. But based on the complexity, material, and printing techniques of the project, we
            offer flexible solutions and strive to accommodate both small-batch startups and large-volume orders.
            Contact us with your specs for a precise quote.</p>
          <h5 style="padding-top: 60px">What sustainable or eco-friendly materials do you offer?</h5>
          <p style="padding-top: 10px">We provide a range of responsible options, including FSC-certified papers, recycled cartons,
            biodegradable plastics, and plant-based inks. We can advise on the best solution to align with your
            sustainability goals.</p>
        </b-col>
        <b-col md="2"></b-col>
        <b-col md="5">
          <h5>Can I get the sample?</h5>
          <p style="padding-top: 10px">Yes, we offer samples for all custom box orders. This allows you to verify all the details before bulk
            production. To request a sample, don’t hesitate to get in touch with our team. We’ll be happy to assist you
            with further.</p>
          <h5 style="padding-top: 60px">How long does production and delivery usually take?</h5>
          <p style="padding-top: 10px">Typical lead times range from 10 to 30 business days after final approval, depending on order complexity
            and quantity. We always provide a detailed timeline upfront and can discuss rush options if needed.</p>
          <h5 style="padding-top: 60px">Do you handle shipping and international logistics?</h5>
          <p style="padding-top: 10px">Yes, we are your full-service partner. We manage reliable shipping, customs documentation, and delivery
            to your specified destination, whether domestically or internationally.</p>
        </b-col>
      </b-row>
    </div>
    <h2 style="padding-top: 80px;padding-bottom: 80px">Get Start with your Personal Package today!</h2>
  </div>
</template>

<style scoped lang="scss">

</style>